import type { Rule } from '../types.js';
import { crossContextRules } from './crossContext.js';
import { hardwareRules } from './hardware.js';
import { consistencyRules } from './consistency.js';
import { automationRules } from './automation.js';
import { integrityRules } from './integrity.js';

export const ALL_RULES: Rule[] = [
  ...crossContextRules,
  ...integrityRules,
  ...hardwareRules,
  ...consistencyRules,
  ...automationRules,
];

export { crossContextRules, hardwareRules, consistencyRules, automationRules, integrityRules };
